import "@/assets/styles/dashboard/dashboard.css";
import { Box, Stack, Typography } from "@mui/material";
import clsx from "clsx";
import { ReactNode } from "react";

interface WidgetsWrapperProps {
	children: ReactNode;
	title?: string;
	icon?: ReactNode;
	isElevated?: boolean;
	disablePadding?: boolean;
	secondaryText?: string;
	footerIcon?: string;
	footerText?: string;
	isDraggable?: boolean;
}
const WidgetsWrapper = (props: WidgetsWrapperProps) => {
	const { children, title, icon, isElevated, disablePadding, secondaryText, isDraggable } = props;

	return (
		<Box
			className={clsx("relative overflow-hidden w-[444px] min-h-[150px] max-h-[544px] !rounded-[10px]", {
				"!bg-white !shadow-widget": isElevated,
				"!bg-layout": !isElevated,
				"p-[1rem_1.2rem]": !disablePadding,
				"blur-[0.5px] border-dashed border-2 rounded-[10px] border-disabled": isDraggable,
			})}
		>
			{title && (
				<Stack direction="row" justifyContent="space-between" alignItems="center" className="mb-[10px]">
					<Box>
						<Typography className="!font-montserrat !font-medium !text-[1.3rem] text-default">{title}</Typography>
						{secondaryText && (
							<Typography className="!font-montserrat !font-medium !text-[1rem] text-neutral-gray">
								{secondaryText}
							</Typography>
						)}
					</Box>
					{icon}
				</Stack>
			)}

			{children}

			{props.footerText && (
				<div className="mt-2 flex justify-end">
					<Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
						{props.footerIcon && <img src={props.footerIcon} alt="Footer Icon" />}
						<Typography className="!font-montserrat !font-medium !text-[0.75rem] text-neutral-gray">
							{props.footerText}
						</Typography>
					</Stack>
				</div>
			)}
		</Box>
	);
};

export default WidgetsWrapper;
